/**
 * THE MAP. Each entry puts a district on the plot grid; streets, bridges,
 * margins, lamps and doors are generated around them (see ./plot.ts).
 *
 *            col 0            col 1            col 2
 *   row 0    Whisper Woods    Windmill Farm    Neon City
 *   row 1    Sakura Hill      Old Town         Pond Park
 *   row 2    Lantern Canals   Meadow & Shore   The Harbour
 *
 * To grow the world: write `districts/<name>.ts` (a 36×32 plot in local
 * coordinates) and add it here at any free (col, row), negative ones too.
 * The river runs down column 0 at local x 16–18 and the sea along row 2's
 * bottom, so neighbours that want them to continue should paint the same.
 */
import type { PlotSlot } from './plot.ts'
import { canals } from './districts/canals.ts'
import { city } from './districts/city.ts'
import { farm } from './districts/farm.ts'
import { harbour } from './districts/harbour.ts'
import { meadow } from './districts/meadow.ts'
import { oldtown } from './districts/oldtown.ts'
import { park } from './districts/park.ts'
import { sakura } from './districts/sakura.ts'
import { woods } from './districts/woods.ts'

export const PLOTS: PlotSlot[] = [
  { col: 0, row: 0, district: woods },
  { col: 1, row: 0, district: farm },
  { col: 2, row: 0, district: city },
  { col: 0, row: 1, district: sakura },
  { col: 1, row: 1, district: oldtown },
  { col: 2, row: 1, district: park },
  { col: 0, row: 2, district: canals },
  { col: 1, row: 2, district: meadow },
  { col: 2, row: 2, district: harbour },
]

/** Where new arrivals appear: the district and the place id inside it. */
export const SPAWN_PLACE = 'square'
